import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';
import { BaseComponent } from 'src/app/shared/base.component';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdminLayoutComponent extends BaseComponent implements OnInit {
  pageTitle = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.updateTitle();
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      this.updateTitle();
      this.cdr.markForCheck();
    });
  }

  async logout(): Promise<void> {
    await this.authService.logout();
    this.router.navigateByUrl('/admin-dash/login');
  }

  navigateTo(path: string): void {
    this.router.navigate([path]); 
  }

  private updateTitle(): void {
    let currentRoute = this.route.snapshot.firstChild;
    while (currentRoute?.firstChild) {
      currentRoute = currentRoute.firstChild;
    }
    this.pageTitle = currentRoute?.data?.['title'] || '';
  }
}